import Model from '../Model'

export default class Article extends Model {
  resource () {
    return 'blog/articles'
  }

  primaryKey () {
    return 'slug'
  }
}
